import React from 'react';

type LinkV1Props = {
    href?: string,
    label?: string | React.JSX.Element,
    classes?: string[],
    attributes?: {
        [key: string]: string
    }
}

const LinkV1 = (props: LinkV1Props) => {

    let classes = ['link-v1'];
    if (Array.isArray(props.classes)) {
        classes.push(...props.classes);
    }

    return (
        <a 
            className={classes.join(' ')}
            href={props.href as string}
            {...props.attributes}
            >
            {props.label as string}
        </a>
    );

}

export default LinkV1;